import { useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { InDevelopment } from '../InDevelopment';
import TreeTableDevices from './TreeTableDevices';
import { TreeTableType } from './TablesHlp';
import DataInFuture from './DataInFuture';

interface IStatiscticsProps {
    tabIsActive: boolean;
}
const Statisctics = (props: IStatiscticsProps) => {
    const [tabIndex, setTabIndex] = useState(0);
    const { tabIsActive } = props;
    const tabs = [
        {
            title: "Заблокированные устройства",
            render: (isActive: boolean) =>
                <TreeTableDevices
                    width={'40rem' }
                    treeTableType={TreeTableType.BlockedDevices}
                    tabIsActive={tabIsActive && isActive}
                />
        },
        {
            title: "Отключенные устройства",
            render: (isActive: boolean) =>
                <TreeTableDevices
                    width={'40rem'}
                    treeTableType={TreeTableType.BannedDevices}
                    tabIsActive={tabIsActive && isActive}
                />
        },
        {
            title: "Устройства с истекающей оплатой",
            render: (isActive: boolean) =>
                <TreeTableDevices
                    width={'60rem'}
                    treeTableType={TreeTableType.ElapsingPayment}
                    tabIsActive={tabIsActive && isActive}
                />
        },
        {
            title: "Устройства с данными в будущем",
            render: () => <DataInFuture />
        },
        {
            title: "Счетчики ошибок по устройствам",
            render: () => <InDevelopment />
        },
    ].filter(Boolean);

    return (
        <Tabs className="modes" onSelect={setTabIndex}>
            <TabList>
                {tabs.map((tab, idx) => (
                    <Tab key={idx} title={tab.title}>
                        <label>{tab.title}</label>
                    </Tab>
                ))}
            </TabList>
            <div style={{ height: '100%' }}>
                {tabs.map((tab, idx) => (
                    <TabPanel key={tab.title} tabIndex={idx} forceRender={true}>
                        {tab.render(tabIndex === idx)}
                    </TabPanel>
                ))}
            </div>            
        </Tabs>
    )
;
};

export default Statisctics;
